import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién empiezo con Flores de Bach?',
  a: 'Especialmente si recién empiezas. El Botiquín Bach te da la estructura táctica desde la primera sesión. No tienes que improvisar ni esperar años. El Tomo I es tu guía de protocolos y síntomas, el Tomo II son tus fórmulas listas para aplicar, y los bonus te enseñan a protegerte y a monetizar. Muchas terapeutas lo usan desde el día 1.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato en 5 minutos. Después de confirmar el pago recibes un email con el link de descarga. Son archivos PDF de alta calidad, descargables y listos para imprimir o usar en tablet. No requiere internet después de descargar.'
}, {
  q: '¿En qué moneda pago?',
  a: 'El precio es de US$19 y se convierte automáticamente a tu moneda local al momento del pago, según el país desde el que compres. Puedes pagar con tarjeta de crédito, débito o PayPal.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No. Muchas terapeutas lo tienen en tablet dentro del consultorio. Otras imprimen solo los tomos, otras solo los bonus. Es completamente flexible. Lo importante es que lo tengas a mano cuando lo necesites.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía sin preguntas. Si en 7 días te das cuenta de que no era para ti, escríbenos y te reintegramos el dinero. Sin letra chica.'
}, {
  q: '¿Puedo compartirlo con otras terapeutas?',
  a: 'No. El Botiquín Bach es para uso personal único y está protegido por derechos de autor. Cada terapeuta necesita su propia licencia. Si quieres regalárselo a una colega, puedes enviarle el link de compra con descuento.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-54" data-mp="mzq54m6kwtew">
      <div className="mb-10 text-center" data-id="element-55" data-mp="myoj5mo0ymie">
        <h2 className="flex justify-center font-display text-2xl font-bold text-brand-green md:text-4xl" data-id="element-56" data-mp="n1stl1s32ehi">
          <span className="mr-3" data-id="element-57" data-mp="2kvx08ljz1x6i">❓</span>LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-4" data-id="element-58" data-mp="2ku3qgxe2awua">
        {faqs.map((faq, index) => <div key={faq.q} className="paper-panel overflow-hidden rounded-2xl border-l-4 border-l-brand-greenMid" data-id="element-59" data-mp="2fxlqsbxl9oot" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-parchment focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber" data-id="element-60" data-mp="2azk7bpw93nct">
              <span className="pr-8 text-sm font-semibold text-brand-green md:text-base" data-id="element-61" data-mp="2ulzxwz21fzb6">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" data-mp="1n8o6y4dqbjty" />
            </button>
            <AnimatePresence initial={false} data-id="element-63" data-mp="3uu6ikbgc8ujh">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-64" data-mp="3urtrn8slr9ua">
                  <p className="border-t border-brand-green/10 bg-white px-6 py-4 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-65" data-mp="hfjlfvbfbby1">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}